export default __webpack_public_path__ + "static/media/Success1.b65a6acc.gif";